import "./OriginHint.css";

/** The only local origin the FPL proxy's CORS policy allows. */
export const ALLOWED_LOCAL_ORIGIN = "http://localhost:3000";

const isLocalHost = (hostname: string) => hostname === "localhost" || hostname === "127.0.0.1" || hostname === "[::1]";

/**
 * Shown next to a load error when the site is running locally on an origin the
 * proxy will refuse, which is the usual cause of "no data" during development.
 */
export const OriginHint = () => {
	const { hostname, origin } = window.location;
	if (!isLocalHost(hostname) || origin === ALLOWED_LOCAL_ORIGIN) {
		return null;
	}
	return (
		<p className="origin-hint">
			The FPL proxy only accepts requests from <span className="mono">{ALLOWED_LOCAL_ORIGIN}</span>, but this page is running at <span className="mono">{origin}</span>. Stop whatever is using port 3000 and start the dev server again.
		</p>
	);
};
